export default __webpack_public_path__ + "static/media/misc-books5-2048w.017e6309.webp";